import React, { Component } from 'react';
import ThemeSelector from '../../themes/theme-selector';

const withGuestIntercom = WrapperComponent => class WithIntercom extends Component {
  componentDidMount = () => {
    const { disableIntercom } = ThemeSelector.theme();
    if (!disableIntercom) {
      const settings = {
        app_id: 'xef2tjr2',
      };
      window.Intercom('boot', settings);
    }
  }
  render() {
    return <WrapperComponent {...this.props} />;
  }
};

export default withGuestIntercom;



/** WEBPACK FOOTER **
 ** ./src/hocs/with-guest-intercom/index.js
 **/